import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export function falsey<T>(src$: Observable<T>): Observable<T> {
  return src$.pipe(filter(val => !val)) as Observable<T>;
}
